export default "__VITE_ASSET__DRWSEpQg__"